import FormatDate from "../Report/FormatDate";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import html2canvas from "html2canvas";
import logo from "../../assets/images/logo.png";
import ValueQRCodeUrl from "./ValueQR";
import QRCodeWithBase64 from "./QRCodeWithBase64";
import ReactDOM from "react-dom";

// pdfmake@0.2.x exports the VFS object directly. Passing the fonts and VFS
// explicitly to createPdf also prevents another PDF module from overwriting
// the global pdfMake font configuration.
const pdfVfs =
    pdfFonts?.pdfMake?.vfs || pdfFonts?.vfs || pdfFonts?.default || pdfFonts;
const pdfFontsConfig = {
    Roboto: {
        normal: "Roboto-Regular.ttf",
        bold: "Roboto-Medium.ttf",
        italics: "Roboto-Italic.ttf",
        bolditalics: "Roboto-MediumItalic.ttf",
    },
};

const defaultImageUrl =
    "https://th.bing.com/th/id/OIP.CF-nc_bSeMzAbjG7KsjXlQHaHa?rs=1&pid=ImgDetMain";

const getBase64Image = (img) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(img);
    });
};
const fetchImageAsBase64 = async (imagePath) => {
    const response = await fetch(imagePath);
    const blob = await response.blob();
    const base64Image = await getBase64Image(blob);
    return base64Image;
};

const compressImage = async (imageFile, maxWidth, maxHeight, quality) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = URL.createObjectURL(imageFile);

        img.onload = () => {
            const canvas = document.createElement("canvas");
            let width = img.width;
            let height = img.height;

            if (width > height) {
                if (width > maxWidth) {
                    height *= maxWidth / width;
                    width = maxWidth;
                }
            } else {
                if (height > maxHeight) {
                    width *= maxHeight / height;
                    height = maxHeight;
                }
            }

            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, width, height);

            canvas.toBlob(
                (blob) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(blob);
                    reader.onloadend = () => resolve(reader.result);
                    reader.onerror = reject;
                },
                "image/jpeg",
                quality
            );
        };

        img.onerror = (error) => reject(error);
    });
};

const getBase64FromUrl = async (url) => {
    try {
        const response = await fetch(url);
        const blob = await response.blob();

        if (!blob.type.startsWith("image/")) {
            throw new Error("Invalid image format");
        }

        const compressedBase64 = await compressImage(blob, 300, 300, 0.1);
        return compressedBase64;
    } catch (error) {
        console.error("Error converting image to base64:", error);
        try {
            const defaultResponse = await fetch(defaultImageUrl);
            const defaultBlob = await defaultResponse.blob();
            const defaultCompressedBase64 = await compressImage(
                defaultBlob,
                300,
                300,
                0.7
            );
            return defaultCompressedBase64;
        } catch (defaultError) {
            console.error("Error loading default image:", defaultError);
            return null;
        }
    }
};
const generateQRCodeBase64 = (value) => {
    return new Promise((resolve) => {
        const qrContainer = document.createElement("div");
        ReactDOM.render(
            <QRCodeWithBase64
                value={value}
                size={200}
                onRenderAsImage={resolve}
            />,
            qrContainer
        );
    });
};

const prepareDataTableWithImages = async (datatable) => {
    const updatedDataTable = await Promise.all(
        datatable.map(async (product) => {
            const qrImage = await generateQRCodeBase64(ValueQRCodeUrl(product));
            const base64Image = await getBase64FromUrl(product.categoryImage);
            return {
                ...product,
                categoryImage: base64Image,
                qrCode: qrImage,
            };
        })
    );
    return updatedDataTable;
};
export const exportFactoryPDF = async (
    action,
    startDate,
    endDate,
    datatableFactory,
    productInprogress,
    productInlate,
    buildingName
) => {
    // Đảm bảo vfs đã được cấu hình
    const donutChartElement = document.getElementById("donut-chart");
    const headerPdfElement = document.getElementById("header-pdf");

    const updatedDataTable = await prepareDataTableWithImages(
        productInprogress
    );
    const updatedDataInlate = await prepareDataTableWithImages(productInlate);
    const imagePath = logo;

    const logoBase64 = await fetchImageAsBase64(imagePath);

    const captureElementAsImage = async (element) => {
        if (!element) return null;
        const canvas = await html2canvas(element);
        return canvas.toDataURL("image/png");
    };

    const [donutChartImgData, headerPdfImgData] = await Promise.all([
        captureElementAsImage(donutChartElement),
        captureElementAsImage(headerPdfElement),
    ]);

    const docDefinition = {
        pageSize: { width: 1200, height: 1000 },
        pageMargins: [40, 60, 40, 60],
        content: [
            {
                image: logoBase64,
                width: 40,
                absolutePosition: { x: 40, y: 50 },
            },
            { text: buildingName, absolutePosition: { x: 100, y: 60 } },
            {
                text: "Báo cáo nhà máy",
                style: "header",
                fontSize: 28,
                margin: [0, 0, 0, 20],
            },
            {
                text: `Từ ngày: ${startDate} ~ Đến ngày: ${endDate}`,
                alignment: "center",
                fontSize: 14,
                margin: [0, 0, 0, 0],
            },
            {
                image: headerPdfImgData,
                margin: [0, 0, 0, 20],
                alignment: "center",
            },
            {
                image: donutChartImgData,
                margin: [20, 20, 20, 20],
                alignment: "center",
            },
            {
                text: "Danh sách hạng mục đang thực hiện",
                style: "subheader",
                pageBreak: "before",
                margin: [0, 0, 0, 5],
                bold: true,
                fontSize: 14,
            },
            {
                table: {
                    headerRows: 1,
                    dontBreakRows: true,
                    keepWithHeaderRows: 1,
                    widths: [
                        "auto",
                        50,
                        100,
                        100,
                        50,
                        50,
                        120,
                        100,
                        100,
                        50,
                        180,
                        100,
                    ],
                    body: [
                        [
                            {
                                text: "STT",
                                bold: true,
                                alignment: "center",
                                fillColor: "#2980BA",
                                color: "#ffffff",
                            },
                            {
                                text: "Mã CT",
                                bold: true,
                                fillColor: "#2980BA",
                                color: "#ffffff",
                                alignment: "center",
                            },
                            {
                                text: "Hạng mục",
                                bold: true,
                                fillColor: "#2980BA",
                                color: "#ffffff",
                            },
                            {
                                text: "Mã nhà máy",
                                bold: true,

                                fillColor: "#2980BA",
                                color: "#ffffff",
                                alignment: "center",
                            },
                            {
                                text: "ĐVT",
                                bold: true,

                                fillColor: "#2980BA",
                                color: "#ffffff",
                                alignment: "center",
                            },
                            {
                                text: "Số lượng",
                                bold: true,
                                alignment: "center",

                                fillColor: "#2980BA",
                                color: "#ffffff",
                                alignment: "center",
                            },
                            {
                                text: "Kế hoạch hoàn thành",
                                bold: true,

                                fillColor: "#2980BA",
                                color: "#ffffff",
                                alignment: "center",
                            },
                            {
                                text: "Định vị",
                                bold: true,

                                fillColor: "#2980BA",
                                color: "#ffffff",
                                alignment: "center",
                            },
                            {
                                text: "Trạng thái",
                                bold: true,

                                fillColor: "#2980BA",
                                color: "#ffffff",
                                alignment: "center",
                            },
                            {
                                text: "Hình ảnh",
                                bold: true,

                                fillColor: "#2980BA",
                                color: "#ffffff",
                                alignment: "center",
                            },
                            {
                                text: "Ghi chú",
                                bold: true,

                                fillColor: "#2980BA",
                                color: "#ffffff",
                                alignment: "center",
                            },
                            {
                                text: "QR Code", // Cột QR
                                bold: true,
                                fillColor: "#2980BA",
                                color: "#ffffff",
                                alignment: "center",
                            },
                        ],
                        ...updatedDataTable?.map((product, index) => [
                            { text: index + 1, alignment: "center" },
                            {
                                text: product.Building.buildingCode,
                            },
                            { text: product.categoryName },
                            {
                                text: product.factoryCode,
                            },
                            { text: product.unit, alignment: "center" },
                            { text: product.quantity, alignment: "center" },
                            {
                                text: FormatDate(product.intendFinishDate),
                            },
                            { text: product.teamWorking, alignment: "center" },
                            { text: product.status, alignment: "center" },
                            {
                                image: product.categoryImage,
                                width: 50,
                                height: 50,
                                fit: [50, 50],
                                alignment: "center",
                            },
                            {
                                text: product.productNote,
                                // alignment: "center",
                            },
                            {
                                image: product.qrCode,
                                width: 60,
                                height: 60,
                                fit: [60, 60],
                                alignment: "center",
                                margin: [0, 10, 0, 10],
                            },
                        ]),
                    ],
                },
            },
            {
                text: "Trễ tiến độ",
                style: "subheader",
                pageBreak: "before",
                margin: [0, 0, 0, 5],
                bold: true,
                fontSize: 14,
            },
            {
                table: {
                    headerRows: 1,
                    dontBreakRows: true,
                    keepWithHeaderRows: 1,
                    widths: ["auto", 100, 150, 150, 50, 50, 120, 100, 180, 100],
                    body: [
                        [
                            {
                                text: "STT",
                                bold: true,
                                alignment: "center",
                                fillColor: "#2980BA",
                                color: "#ffffff",
                            },
                            {
                                text: "Công trình",
                                bold: true,

                                fillColor: "#2980BA",
                                color: "#ffffff",
                            },
                            {
                                text: "Hạng mục",
                                bold: true,
                                fillColor: "#2980BA",
                                color: "#ffffff",
                            },
                            {
                                text: "Mã nhà máy",
                                bold: true,

                                fillColor: "#2980BA",
                                color: "#ffffff",
                            },
                            {
                                text: "ĐVT",
                                bold: true,

                                fillColor: "#2980BA",
                                color: "#ffffff",
                            },
                            {
                                text: "Số lượng",
                                bold: true,
                                alignment: "center",

                                fillColor: "#2980BA",
                                color: "#ffffff",
                            },
                            {
                                text: "Ngày hoàn thành",
                                bold: true,

                                fillColor: "#2980BA",
                                color: "#ffffff",
                            },
                            {
                                text: "Định vị",
                                bold: true,
                                fillColor: "#2980BA",
                                color: "#ffffff",
                            },
                            {
                                text: "Ghi chú",
                                bold: true,
                                fillColor: "#2980BA",
                                color: "#ffffff",
                            },
                            {
                                text: "QR Code", // Cột QR
                                bold: true,
                                fillColor: "#2980BA",
                                color: "#ffffff",
                            },
                        ],
                        ...updatedDataInlate?.map((product, index) => [
                            { text: index + 1, alignment: "center" },
                            {
                                text: product.Building.buildingCode,
                            },
                            { text: product.categoryName },
                            {
                                text: product.factoryCode,
                            },
                            { text: product.unit },
                            { text: product.quantity, alignment: "center" },
                            {
                                text: FormatDate(product.endedDate),
                            },
                            {
                                text: product.teamWorking,
                            },
                            {
                                text: product.productNote,
                            },
                            {
                                image: product.qrCode,
                                width: 60,
                                height: 60,
                                fit: [60, 60],
                                alignment: "center",
                                margin: [0, 10, 0, 10],
                            },
                        ]),
                    ],
                },
            },
        ],
        styles: {
            header: {
                fontSize: 18,
                bold: true,
                alignment: "center",
            },
        },
        defaultStyle: {
            font: "Roboto",
        },
    };

    const pdfDocGenerator = pdfMake.createPdf(
        docDefinition,
        null,
        pdfFontsConfig,
        pdfVfs
    );

    if (action === "print") {
        pdfDocGenerator.getBlob((blob) => {
            const url = URL.createObjectURL(blob);
            const newWindow = window.open(url, "_blank");
            if (newWindow) {
                newWindow.onload = () => {
                    newWindow.print();
                };
            }
        });
    } else if (action === "save") {
        pdfDocGenerator.download("factory.pdf");
    }
    // });
};
